var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"opacity":"0"}},[_vm._v("空态占位符")])}
var staticRenderFns = []

export { render, staticRenderFns }